import { getTrackerConfig } from '@/config/getTrackerConfig.ts';

export function getHydraConfig() {
  return getTrackerConfig('hydra');
}
